// Google compatibility tokens live only in memory; persistence is a secure httpOnly cookie.
let managedToken = null;
export const getAccessToken = () => managedToken || localStorage.getItem('notary_token');
export const setManagedToken = (token) => { managedToken = token; };